/* eslint-disable @typescript-eslint/no-explicit-any */
"use client";

import { useLayoutEffect, useCallback } from "react";

export const useFacetOutsideClick = (
  ref: any,
  facetId: string,
  callback: (e: any) => void
) => {
  // checks if clicked target element is within ref.current DOM element
  const handleClick = useCallback(
    (event: MouseEvent) => {
      if (ref.current && !ref.current.contains(event.target)) {
        const clickedTarget = event.target as any;
        if (!clickedTarget) return;

        const clickedTargetId = clickedTarget.id;
        const clickedTargetClass = clickedTarget.className;

        // skip on classes: facet, checkbox
        if (["facet", "checkbox", "applyBtn"].includes(clickedTargetClass)) {
          return;
        }

        // skip on click on <summary />
        if (clickedTargetId === `filters.summary.${facetId}`) {
          return;
        }

        // skip?
        callback(event);
      }
    },
    [callback, facetId, ref]
  );

  useLayoutEffect(() => {
    document.addEventListener("click", handleClick, true);

    return () => {
      document.removeEventListener("click", handleClick, true);
    };
  }, [callback, ref, handleClick]);

  return ref;
};
